<template>
  <div class="case">
    <banner title="经典案例" />
    <div class="case-section">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(item,index) in caseList" :key="index">
          <img :src="item.imgurl" />
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{item.title}}</p>
            <p class="abstract-content">{{item.Content}}</p>
            <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: item.Id,item }}"
              >
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      caseList: [
        {
            Id:1,
            title:"沙坪坝区迈瑞城投健康城项目",
            CreateTime:"沙坪坝区迈瑞城投健康城项目无人机航摄正射影像生产成果",
            Content:"该项目是我公司受重庆迈瑞城投有限公司委托，对沙坪坝区健康城项目进行无人机航摄，制作高精度影像图。影像分辨率为5公分，1:500比例尺。利用高精度影像对项目区的土地利用现状、建筑情况进行摸底调查。",
            imgurl:require('../assets/img/cass1.jpg')
        },
        {
            Id:2,
            title:"云阳-石缸景区1:2000地形测量",
            CreateTime:"云阳-石缸景区1:2000地形测量",
            Content:" 外业采用油动固定翼搭载索尼A7R2（35mm）进行航片采集，结合RTK制作地面相控。内业采用密集点云、DOM、DEM数字高程模型进行高程点采集和地物绘制。多数据模型结合制作而成。",
            imgurl:require('../assets/img/cass2.jpg')
        },
        {
            Id:3,
            title:"沙坪坝区博物馆三维重建",
            CreateTime:"沙坪坝区博物馆三维重建",
            Content:"沙坪坝区博物馆为古代中式风格建筑物。博物馆占地面积约1500平方米。我们采用小精灵进行五条航带飞行数据采集。利用ContextCapture 软件即可制作三维实景模型。同时也可发布到网络共享。",
            imgurl:require('../assets/img/cass3.jpg')
        },
        {
            Id:4,
            title:"沙坪坝融汇温泉城三维重建",
            CreateTime:"沙坪坝融汇温泉城三维重建",
            Content:"该模型为城市重建区，涉及高层建筑、坡地等复杂区。采用大疆M600 Pro搭载睿铂Riy-D2五镜头，飞行高度300米，2架次完成1.4平方公里三维建模。在模型中可对土石方等工程建设方量进行测算。",
            imgurl:require('../assets/img/cass4.jpg')
        },
         {
            Id:5,
            title:"地理信息系统",
            CreateTime:"地理信息系统",
            Content:"公司自主研发的地理信息管理系统软件，将无人机测量和传统测绘相结合，建立完善数据库，是行业内少有的数据整合系统。我司将此软件功能进行了延伸，研发出了“重庆市园区建设管理系统”和“重庆市土地巡查看护系统”，这将给客户带来便捷与高效。",
            imgurl:require('../assets/img/cass6.jpg')
        },
         {
            Id:6,
            title:"地理信息系统",
            CreateTime:"地理信息系统",
            Content:" 公司自主研发的地理信息管理系统软件，将无人机测量和传统测绘相结合，建立完善数据库，是行业内少有的数据整合系统。我司将此软件功能进行了延伸，研发出了“重庆市园区建设管理系统”和“重庆市土地巡查看护系统”，这将给客户带来便捷与高效。",
            imgurl:require('../assets/img/cass7.jpg')
        },
         {
            Id:7,
            title:"地理信息系统",
            CreateTime:"地理信息系统",
            Content:" 公司自主研发的地理信息管理系统软件，将无人机测量和传统测绘相结合，建立完善数据库，是行业内少有的数据整合系统。我司将此软件功能进行了延伸，研发出了“重庆市园区建设管理系统”和“重庆市土地巡查看护系统”，这将给客户带来便捷与高效。",
            imgurl:require('../assets/img/cass8.jpg')
        },
         {
            Id:8,
            title:"地理信息系统",
            CreateTime:"地理信息系统",
            Content:" 公司自主研发的地理信息管理系统软件，将无人机测量和传统测绘相结合，建立完善数据库，是行业内少有的数据整合系统。我司将此软件功能进行了延伸，研发出了“重庆市园区建设管理系统”和“重庆市土地巡查看护系统”，这将给客户带来便捷与高效。",
            imgurl:require('../assets/img/cass9.jpg')
        },
      ]
    };
  },
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #14679f;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;
            text-indent: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>